import { useCallback, useMemo, useRef, useState } from "react";

/** Rows ticked for a bulk action in any table (ported). Only what the table still shows counts; Shift takes the rows in between. */
const rangeBetween = (order: string[], from: string | null, to: string) => { const a = from ? order.indexOf(from) : -1, b = order.indexOf(to); if (a < 0 || b < 0) return [to]; const [x, y] = a < b ? [a, b] : [b, a]; return order.slice(x, y + 1); };
export function useTicked(order: string[]) {
  const [set, setSet] = useState<Set<string>>(new Set());
  const last = useRef<string | null>(null);
  const ids = useMemo(() => order.filter((id) => set.has(id)), [order, set]);
  const tick = useCallback((id: string, on: boolean, range = false) => {
    const span = range ? rangeBetween(order, last.current, id) : [id];
    setSet((cur) => { const n = new Set(cur); for (const x of span) { if (on) n.add(x); else n.delete(x); } return n; });
    last.current = id;
  }, [order]);
  const all = useCallback(() => setSet(new Set(order)), [order]);
  const clear = useCallback(() => { setSet(new Set()); last.current = null; }, []);
  return { ids, has: (id: string) => set.has(id), tick, all, clear, allOn: order.length > 0 && ids.length === order.length };
}
